import { VerticalContainer } from '@american-autonomy/ag-ui';

import Form from 'components/Form';
import FormSubmitPanel from 'components/FormSubmitPanel';
import ApplicationFormFields from 'components/forms/ApplicationFormFields';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const UpdateApplicationForm: FunctionComponent<Props> = ({
    className = '',
    formValues,
    isClosing,
    onClose,
    setIsClosing,
    testId = TEST_ID
}) => {
    const { SAVE } = useTranslation();
    const { confirmationPanel, errors, form, handleSubmit, onSubmit, showConfirmation } = useData({
        formValues,
        isClosing,
        onClose,
        setIsClosing
    });

    return (
        <VerticalContainer
            className={`${styles.updateApplicationForm} ${className}`}
            testId={testId}>
            {showConfirmation ? (
                confirmationPanel
            ) : (
                <Form form={form}>
                    <ApplicationFormFields />

                    <FormSubmitPanel
                        buttonText={SAVE}
                        className={styles.formSubmitPanel}
                        errors={errors}
                        onSubmit={handleSubmit(onSubmit)}
                    />
                </Form>
            )}
        </VerticalContainer>
    );
};

export default UpdateApplicationForm;
